module.exports = __webpack_public_path__ + "img/bullhorn.ea83cca5.svg";